import { render } from "./BestSolutionTabs.vue?vue&type=template&id=cd2658ba&scoped=true"
import script from "./BestSolutionTabs.vue?vue&type=script&lang=js"
export * from "./BestSolutionTabs.vue?vue&type=script&lang=js"

import "./BestSolutionTabs.vue?vue&type=style&index=0&id=cd2658ba&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd2658ba"]])

export default __exports__